export default "__VITE_ASSET__BxMAi4Q4__"